// Auth
export const urlRefreshToken = 'auth/refresh-token';
export const urlApiAuth = {
  login: 'auth/login',
  refreshToken: 'auth/refresh-token',
};

// User
export const urlApiUser = {
  profile: 'users/profile',
  changePassword: 'users/change-password',
};
